import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { MyOrdersModalComponent } from '../my-orders-modal/my-orders-modal.component';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { OrderNotExistModalComponent } from '../order-not-exist-modal/order-not-exist-modal.component';
import { SelectLanguageModalComponent } from '../select-language-modal/select-language-modal.component';
import { BarrierefreiheitPage } from 'src/app/pages/accessibility-statement/accessibility-statement.page';

enum Language {
	GreatBritain = 'en',
	German = 'de',
	Czech = 'cr',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
	standalone: false,
})
export class MenuModalComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	languageEnum = Language;

	constructor(
		public repository: RepositoryService,
		private router: Router,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {
		super(repository);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.loadOrders();
	}

	async loadOrders() {
		console.log('load orders', !this.customer);
		if (!this.customer) {
			console.log('user not loaded');
			return;
		}
		try {
			const result = await Api.getCustomerOrders(this.customer.uid);
			if (result.data.withPayment) {
				const resultOrders = result.data.withPayment.filter(it => it?.preorder?.type !== PreorderType.FOOD_SPOT);
				console.log(resultOrders);
			}
		} catch (e) {}
	}

	async myOrders() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		MyOrdersModalComponent.show(this.modalController, this.repository.customer);
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.privacy();
		} catch (e) {
			await this.navigationService.privacy();
		}
	}

	async tos() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.tos();
		} catch (e) {
			await this.navigationService.tos();
		}
	}

	async accessibility() {
		await this.modalController.dismiss();
		await BarrierefreiheitPage.navigate(this.router);
	}

	async impressum() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.imprint();
		} catch (e) {
			await this.navigationService.imprint();
		}
	}

	async allergens() {
		await this.modalController.dismiss();
		// TODO open PDF
	}

	dismiss() {
		this.modalController.dismiss();
	}
	async cookie() {
		await this.modalController.dismiss();

		this.navigationService.cookie();
	}

	close() {
		this.modalCtrl.dismiss();
	}

	changeLang(language: string) {
		this.translate.use(language);
	}
}
